export const formFieldOnScanEdit = Object.freeze({
	OnlyOverwriteEmptyInput: 1,
	AlwaysOverwriteInput: 2,
	AlwaysOverwriteInputExceptBlanks: 3,
	NeverOverwriteInput: 4,
});
